import React from 'react'
import {
  GridColumnMenu,
  GridColumnMenuProps,
  GridColumnMenuContainer,
  GridColumnMenuColumnsItem,
  GridColumnMenuSortItem,
} from '@mui/x-data-grid'
import { Divider } from '@mui/material'
import { DynamicColumnFilter } from './DynamicColumnFilter'

export interface DynamicColumnMenuProps extends GridColumnMenuProps {
  filterableColumns?: Record<string, string>
  fetchFilterValues?: (
    columnName: string,
    offset?: number,
    sortOrder?: string
  ) => Promise<{
    items: string[]
    total_count: number
    has_more: boolean
    next_offset: number
    has_empty_values?: boolean
  }>
  cachePrefix?: string
  dynamicFilters?: Record<string, string[]>
  setDynamicFilters?: React.Dispatch<React.SetStateAction<Record<string, string[]>>>
  sortModel?: any
}

export const DynamicColumnMenu: React.FC<DynamicColumnMenuProps> = (props) => {
  const {
    filterableColumns = {},
    fetchFilterValues,
    cachePrefix = 'table',
    dynamicFilters = {},
    setDynamicFilters,
    colDef,
    hideMenu,
    sortModel,
  } = props

  const filterLabel = filterableColumns[colDef.field]
  const sortOrder = sortModel?.find((s: any) => s.field === colDef.field)?.sort

  const fetchValuesApi = React.useCallback(
    (offset?: number) => {
      if (!fetchFilterValues) {
        return Promise.resolve({ items: [], total_count: 0, has_more: false, next_offset: 0 })
      }
      return fetchFilterValues(colDef.field, offset, sortOrder)
    },
    [fetchFilterValues, colDef.field, sortOrder]
  )

  if (filterLabel && fetchFilterValues && setDynamicFilters) {
    return (
      <GridColumnMenuContainer {...props}>
        <DynamicColumnFilter
          cacheKey={`${cachePrefix}-${colDef.field}-${sortOrder || 'none'}`}
          columnName={colDef.field}
          label={filterLabel}
          fetchValuesApi={fetchValuesApi}
          selectedValues={dynamicFilters[colDef.field] || []}
          colDef={colDef}
          onChange={(values) => {
            setDynamicFilters((prev) => ({
              ...prev,
              [colDef.field]: values,
            }))
          }}
        />
        <Divider sx={{ my: 1 }} />
        <GridColumnMenuSortItem colDef={colDef} onClick={hideMenu!} />
        <Divider sx={{ my: 1 }} />
        <GridColumnMenuColumnsItem colDef={colDef} onClick={hideMenu!} />
      </GridColumnMenuContainer>
    )
  }

  return <GridColumnMenu {...props} />
}

export default DynamicColumnMenu
